<template>
  <div>
    <ListPage
      title="Campaigns"
      :headers="headers"
      :items="data.items"
      :view="['table']"
    >
      <template #charts>
        <v-col cols="12" sm="6">
          <v-card class="mx-auto text-center" :height="300">
            <v-card-text>
              <CampaignImpressionsDistribution />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card class="mx-auto text-center" :height="300">
            <v-card-text>
              <CampaignsLatest5Performance :value="stats.latest5Performance" />
            </v-card-text>
          </v-card>
        </v-col>
      </template>

      <template #actions>
        <v-btn
          variant="text"
          class=""
          color="primary"
          @click="() => (newDialog = !newDialog)"
        >
          <template #prepend>
            <v-icon>mdi-plus</v-icon>
          </template>
          Advertise
        </v-btn>
      </template>
      <template #card="{ item }">
        <CampaignCardItem
          :value="item"
          @on-details="onDetails"
          @on-share="onShare"
        />
      </template>

      <template #row="{ item, headers }">
        <CampaignTableItem
          @on-details="onDetails"
          :value="item"
          :headers="headers"
        />
      </template>
    </ListPage>
    <CampaignCreateDialog v-model="newDialog" @create="create" />
  </div>
</template>

<script>
import ListPage from "../../components/organisms/layout/ListPage.vue";
import CampaignCreateDialog from "../../components/organisms/campaign/CampaignCreateDialog.vue";
import CampaignCardItem from "../../components/organisms/campaign/CampaignCardItem.vue";
import CampaignTableItem from "../../components/organisms/campaign/CampaignTableItem.vue";
import { CampaignAPIInstance } from "../../api";
import CampaignImpressionsDistribution from "@/components/molecules/campaign/analytics/CampaignImpressionsDistribution.vue";
import CampaignsLatest5Performance from "@/components/molecules/campaign/analytics/CampaignsLatest5Performance.vue";

export default {
  name: "CampaignList",
  components: {
    CampaignCardItem,
    CampaignTableItem,
    ListPage,
    CampaignCreateDialog,
    CampaignImpressionsDistribution,
    CampaignsLatest5Performance,
  },
  data() {
    return {
      newDialog: false,
      headers: [
        // { title: "Select", key: "Select" },
        { title: "ID", key: "id" },
        { title: "Risk", key: "Risk" },
        { title: "Type", key: "Type" },
        { title: "Status", key: "Status" },
        { title: "Duration", key: "Duration" },
        { title: "Name", key: "name" },
        { title: "Impressions", key: "Impressions" },
        { title: "Views", key: "Views" },
        { title: "Clicks", key: "Clicks" },
        { title: "Created", key: "created_at" },
      ],
      data: {
        items: [],
        pagination: {
          page: 1,
          pageSize: 10,
        },
      },
      stats: {
        latest5Performance: [],
      },
    };
  },
  computed: {},

  created() {
    this.getList();
    this.getStats();
  },
  methods: {
    async getStats() {
      const [latest5Performance] = await Promise.all([
        CampaignAPIInstance.Analytics.latest5Performance(),
      ]);
      this.stats.latest5Performance = latest5Performance.data;
    },
    async getList() {
      const { items, pagination } = await CampaignAPIInstance.list(
        this.data.pagination
      );

      this.data.items = items;
      this.data.pagination = pagination;
    },
    async create(campaign) {
      console.log("create", campaign);

      const formData = new FormData();

      formData.append("name", campaign.name);
      formData.append("settings", JSON.stringify(campaign.settings));
      formData.append("targeting", JSON.stringify(campaign.targeting));
      formData.append("budget", JSON.stringify(campaign.budget));
      formData.append("goal", JSON.stringify(campaign.goal));
      formData.append("creatives", JSON.stringify(campaign.creatives));
      formData.append("risk", JSON.stringify(campaign.risk));
      formData.append("timezone", Intl.DateTimeFormat().resolvedOptions().timeZone);

      formData.append(
        "type",
        JSON.stringify({
          id: campaign.type.id,
          code: campaign.type.code,
        })
      );

      campaign.creatives
        .reduce((acc, creative) => {
          return [
            ...acc,
            ...Object.keys(creative)
              .filter((a) => creative[a].file)
              .map((a) => creative[a].file),
          ];
        }, [])
        .forEach((file) => {
          formData.append("assets", file);
        });

      await CampaignAPIInstance.create(formData, {
        toast: {
          message: "Campaign Created",
          color: "success",
        },
      });

      this.newDialog = false;

      this.getList();
      this.getStats();
    },
    onDetails(campaign) {
      this.$router.push(`/campaigns/${campaign.id}`, {
        params: { id: campaign.id },
      });
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>
</style>